<div class="radial">
  <div class="radial__inner">
    <i class="icon-arrow" [style.transform]="arrowTransform"></i>
  </div>
  <svg width="100%" height="100%" viewBox="0 0 40 40">
    <defs>
      <linearGradient id="linear" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" class="start-color"/>
        <stop offset="100%" class="stop-color"/>
      </linearGradient>
    </defs>

    <circle cx="20" cy="20" [attr.r]="normalizedRadius" fill="none" [attr.stroke-width]="strokeWidth()"
            class="progress-bg"></circle>
    <circle cx="20" cy="20" [attr.r]="normalizedRadius" fill="none" [attr.stroke-width]="strokeWidth()"
            [attr.stroke-dasharray]="circleLength" [attr.stroke-dashoffset]="calcProgress()" class="progress"
            stroke="url(#linear)"></circle>
  </svg>
</div>
